import {
  NETWORK_START,
  NETWORK_STOP,
  NETWORK_ERROR,
  ADVERTISING_SET
} from "../constants/action-types";

import { fetchActiveAdvertising } from '../../utils/requestHelper';

export function getAdvertising(){
  return async (dispatch) => {
    try {
      dispatch({ type: NETWORK_START });

      const result = await fetchActiveAdvertising();
      if (result.success === true) {
        dispatch({
          type: ADVERTISING_SET,
          result: result.data.data
        });
      }

      dispatch({ type: NETWORK_STOP });
    } catch (error) {
      dispatch({ type: NETWORK_STOP });
      dispatch({ type: NETWORK_ERROR, error });
    }
  };
}
